import {
    executeJsonPostMethod
} from '../api/rest/restApiUtils'
import { WordDto } from '../types/api'

/**
 * generateAIWordListCard
 * @method create
 * @param  {number}  cardList - id списка слов
 * @return {Response} Fetch Response
 */
export function generateAIWordListCard(cardList: number, words: Array<WordDto>) {
    let canceledWords = {
        words: words.map(w => {
            return {
                ...w,
                id: 0
            }
        })
    }
    return executeJsonPostMethod(`/openai/wordlist/${cardList}/ai-card`, canceledWords).then((resp) => {
        return resp.data
    })
}

/**
 * generateAICardList
 * @method create
 * @return {Response} Fetch Response
 */
export function generateAICardList(cardList: any) {
    return executeJsonPostMethod(`/openai/wordlist/ai-card-list`, cardList).then((resp) => {
        return resp.data
    })
}




